import type { Filter } from "../../../../components/FilterChips/FilterChips";

import type { SearchServiceSort } from "../../../../api/hooks";

import type { CompetencySortBy, ListCompetenciesParams } from "../../../../api/services/defs/competencies";

import { getNonDismissibleChipIds, resolveStatus } from "../../../../utils/statusFilter";

import { type CompetenciesFilters, STATUS_LABELS } from "./schema";

type FiltersInput = Partial<CompetenciesFilters>;

export const convertFiltersToFilterChips = (filters: FiltersInput): Filter[] => {
	const chips: Filter[] = [
		{ id: "status", type: "string", label: "Status", value: STATUS_LABELS[resolveStatus(filters)] },
	];

	if (filters.companyWide === true) {
		chips.push({ id: "companyWide", type: "string", label: "", value: "Company Wide" });
	}

	return chips;
};

export { getNonDismissibleChipIds };

type CompetenciesRequestParams = Pick<
	ListCompetenciesParams,
	"name" | "status" | "companyWide" | "sortBy" | "sortOrder"
>;

export const colIdToSortBy = (colId: string | undefined): CompetencySortBy | null => {
	if (colId === "name" || colId === "status") return colId;
	if (colId === "levels") return "levels_count";
	return null;
};

export const getCompetenciesListParams = (
	filters: FiltersInput,
	searchValue: string,
	sort?: SearchServiceSort
): CompetenciesRequestParams => {
	const params: CompetenciesRequestParams = { status: resolveStatus(filters) };

	const trimmedSearch = searchValue.trim();
	if (trimmedSearch) {
		params.name = trimmedSearch;
	}

	if (filters.companyWide === true) {
		params.companyWide = true;
	}

	if (sort?.name) {
		const mapped = colIdToSortBy(sort.name);
		if (mapped) {
			params.sortBy = mapped;
			params.sortOrder = sort.direction === "desc" ? "desc" : "asc";
		}
	}

	return params;
};
